import {
    ArrayInput,
    SimpleFormIterator,
    TextInput,
    required,
} from 'react-admin';
import { Stack, Typography } from '@mui/material';
import { validateLastFour } from './userCreditCardValidation';

export const UserCreditCardInputs = () => {
    return (
        <Stack flex={1} gap={2}>
            <Typography variant="h6">Credit Cards</Typography>
            <Typography variant="body2" color="textSecondary">
                Only the last 4 digits of each card are stored.
            </Typography>
            <ArrayInput
                source="credit_cards"
                label={false}
            >
                <SimpleFormIterator
                    inline
                    disableReordering
                >
                    <TextInput
                        source="last_four"
                        label="Last 4 digits"
                        inputProps={{
                            inputMode: 'numeric',
                            maxLength: 4,
                        }}
                        validate={[required(), validateLastFour]}
                        helperText="4 digits (e.g., 1234)"
                    />
                </SimpleFormIterator>
            </ArrayInput>
        </Stack>
    );
};

UserCreditCardInputs.displayName = 'UserCreditCardInputs';
